import { TSyncProp } from '@ui/frontend-app-state-sync';

function isObject(value: any) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

function isBoolean(value: any) {
  return value === true || value === false;
}

export function isSyncPropExist(syncProp: TSyncProp): boolean {
  return Array.isArray(syncProp) || isObject(syncProp) || isBoolean(syncProp) || !!syncProp;
}
